module.exports = __webpack_public_path__ + "static/google-play-badge-d4028b650237a4a1d441fa6361dfa842.png";